module.exports = __webpack_public_path__ + "media/case3_mob.9b46ea20.mp4";